import { render, staticRenderFns } from "./titles.vue?vue&type=template&id=3fbc69fe&scoped=true&"
import script from "./titles.vue?vue&type=script&lang=js&"
export * from "./titles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbc69fe",
  null
  
)

export default component.exports